import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import { Navigation, Pagination } from "swiper/modules";
import { CloseIcon } from "./Icons/CloseIcon";


interface GalleryModalProps {
  images: string[];
  onClose: () => void;
}

const GalleryModal: React.FC<GalleryModalProps> = ({ images, onClose }) => {
  return (
    <div 
        className="fixed inset-0 bg-[#090a14] bg-opacity-90 flex items-center justify-center" 
        style={{zIndex:900}}
    >
      {/* Bezáró gomb */}
      <button
        className="absolute top-4 right-4 text-white p-2 rounded-full" 
        style={{zIndex:950, backgroundColor: "#3F4067"}}
        onClick={onClose}
      >
        <CloseIcon />
      </button>

      {/* Swiper galéria */}
      <Swiper
        modules={[Navigation, Pagination]}
        navigation
        pagination={{ clickable: true }}
        className="w-full h-full"
      >
        {images.map((src, index) => (
          <SwiperSlide key={index} className="flex items-center justify-center">
            <img
              src={src}
              alt={`item${index + 1}`}
              className="max-h-screen max-w-full object-contain"
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default GalleryModal;